import { render } from "./OrderPoolChooseService.vue?vue&type=template&id=4adfb95a&scoped=true&ts=true"
import script from "./OrderPoolChooseService.vue?vue&type=script&lang=ts"
export * from "./OrderPoolChooseService.vue?vue&type=script&lang=ts"

import "./OrderPoolChooseService.vue?vue&type=style&index=0&id=4adfb95a&lang=sass&scoped=true"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4adfb95a"]])

export default __exports__